<ng-container *transloco="let t">
  <p class="label" [ngClass]="{'invalid': IsInValid()}">{{label}}</p>
  <input type="text" class="input" [ngClass]="{'invalid': IsInValid()}" [formControl]="formGroup.controls.name" (click)="openPopUp()"
         readonly [placeholder]="label">
  <app-select-popup [(isOpen)]="popupVisible" [dynamicComponent]="OptionsComponent" [data]="options" [hint]="hint" [title]="label" (selected)="setSelected($event)" ></app-select-popup>
  <div *ngIf="IsInValid()" class="error">
    <img src="/assets/warning.png">
    <p>{{ t('COMMON.INPUT.SELECT.ERROR-PREFIX') }}{{label}}</p>
  </div>
</ng-container>
